var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',_vm._b({on:{"click":_vm.hideSidebar}},'md-list-item',_vm.$attrs,false),[_vm._t("default",[_c('md-icon',[_vm._v(_vm._s(_vm.link.icon))]),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0b82612","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarPlugin/SidebarLink.vue
// module id = null
// module chunks = 